var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import styled, { css, ThemeProvider } from 'styled-components';
import { SourceIcon, SourceLookup } from '../../../Atoms/Icon';
import Badge from '../../../Atoms/Badge';
import { DefaultTheme } from '../../../Themes';
import { SourceBadgeType } from './types';
const StyledBadge = styled(Badge) `
  color: ${({ theme }) => theme.ThemeColors.WHITE.hex};
  border-left: ${({ secondaryColor }) => secondaryColor ? `4px ${secondaryColor}` : ''};

  ${({ primaryColor }) => css `
    background-color: ${primaryColor};
    border: 1px solid ${primaryColor};
  `}
`;
const getSourceBadgeConfig = (type) => {
    if (Object.values(SourceBadgeType).includes(type)) {
        return SourceLookup[type];
    }
    return SourceLookup[SourceBadgeType.UNKNOWN];
};
const SourceBadge = (_a) => {
    var { type = SourceBadgeType.UNKNOWN, theme = DefaultTheme } = _a, rest = __rest(_a, ["type", "theme"]);
    const sourceBadgeConfig = getSourceBadgeConfig(type);
    return (React.createElement(ThemeProvider, { theme: theme },
        React.createElement(StyledBadge, Object.assign({}, rest, { primaryColor: sourceBadgeConfig.primaryColor, secondaryColor: sourceBadgeConfig.secondaryColor, title: sourceBadgeConfig.name }),
            React.createElement(SourceIcon, Object.assign({ invertColors: true }, sourceBadgeConfig)))));
};
export default SourceBadge;
